import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  providerFields: yup.array().of(yup.string()),

  api_key: yup.string().when(["providerFields"], {
    is: (providerFields) => providerFields?.includes("api_key"),
    then: (schema) => schema.required("API key is required"),
    otherwise: (schema) => schema.optional(),
  }),

  merchant_code: yup.string().when(["providerFields"], {
    is: (providerFields) => providerFields?.includes("merchant_code"),
    then: (schema) => schema.required("Merchant code is required"),
    otherwise: (schema) => schema.optional(),
  }),

  merchant_name: yup.string().when(["providerFields"], {
    is: (providerFields) => providerFields?.includes("merchant_name"),
    then: (schema) => schema.required("Merchant name is required"),
    otherwise: (schema) => schema.optional(),
  }),

  webhook_secret: yup.string().when(["providerFields"], {
    is: (providerFields) => providerFields?.includes("webhook_secret"),
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.optional(),
  }),

  opay_public_key: yup.string().when(["providerFields"], {
    is: (providerFields) => providerFields?.includes("opay_public_key"),
    then: (schema) => schema.required("Public key is required"),
    otherwise: (schema) => schema.optional(),
  }),

  client_auth_key: yup.string().when(["providerFields"], {
    is: (providerFields) => providerFields?.includes("client_auth_key"),
    then: (schema) => schema.required("Client auth key is required"),
    otherwise: (schema) => schema.optional(),
  }),
});

const useValidation = ({ ...formDetails }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...formDetails,
    },
  });
};

export default useValidation;
